import createAction from "../../../actions/safeCreateAction";
// Change a specific load order entry.
export const setFBLoadOrderEntry = createAction("SET_FB_LOAD_ORDER_ENTRY", (profileId, loEntry) => ({ profileId, loEntry }));
export const setFBLoadOrder = createAction("SET_FB_LOAD_ORDER", (profileId, loadOrder) => ({ profileId, loadOrder }));
